import { create } from "zustand";
import { fetchLogin } from "./Services/fetchlogin";
import { fetchContact } from "./Services/fetchContact";
import { getInitialLanguage } from "./Utilities/Language/language";

const useStore = create((set, get) => ({
  loading: false,
  error: null,
  success: null,
  language: getInitialLanguage(),

  setLanguage: (language) => {
    try {
      localStorage.setItem("language", language);
    } catch (e) {}
    set({ language });
  },

  resetError: () => set({ error: null }),
  resetSuccess: () => set({ success: null }),

  fetchDataLogin: async (body) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchLogin(body);
      if (response.statusCode !== 200) {
        set({ loading: false, error: response.message || "No se pudo iniciar sesión" });
        return;
      }
      try {
        localStorage.setItem("logindata", JSON.stringify({ data: { token: response.token } }));
        localStorage.setItem("token", response.token);
        if (response.role) localStorage.setItem("role", response.role);
        if (response.userId) localStorage.setItem("userId", response.userId);
      } catch (e) {}
      set({ loading: false, success: response.message || "Bienvenido" });
      window.dispatchEvent(new Event("authChange"));
    } catch (error) {
      set({ loading: false, error: error.message });
    }
  },

  fetchSendContact: async (body) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchContact(body);
      if (response.statusCode !== 200) {
        set({ loading: false, error: response.message || "No pudimos enviar tu mensaje" });
        return { sent: false, statusCode: response.statusCode };
      }
      set({ loading: false, success: response.message || "Mensaje enviado" });
      return { sent: true, statusCode: response.statusCode };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { sent: false, statusCode: 500 };
    }
  },

  // --- Agregar aquí nuevas acciones ---
}));

export default useStore;
